<script>
export default {
    name: 'IconDocument'
}
</script>
<template>
    <svg
        class="base-icon icon-document"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 8v48H12V8h40zM32 40H18v4h14v-4zm14-10H18v4h28v-4zm0-10H18v4h28v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
